module.exports = __webpack_public_path__ + "static/media/cw.a5487f56.svg";